import script from "./ResearchPaperAutoFillExtract.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResearchPaperAutoFillExtract.vue?vue&type=script&setup=true&lang=ts"

import "./ResearchPaperAutoFillExtract.vue?vue&type=style&index=0&id=68a72918&lang=css"

const __exports__ = script;

export default __exports__